export default __webpack_public_path__ + "static/media/SWT1180.34I-43168_-25823_0.65ceca77.jpg";